import { useEffect, useState } from 'react'
import { LANGUAGE_EN } from '@edulastic/constants/const/languages'
import {
  getAvailableLanguageKeysInItem,
  getAvailableLanguageKeysInPassage,
} from '../../../utils/helpers'
import { filterAndOrderByLanguageOptions } from '../../../../author/questionUtils'

const useQuestionLanguageTab = ({
  item,
  isLCB,
  isEditView,
  setLanguage,
  passage,
  allowedToSelectMultiLanguage,
  setLanguageTabs,
  languageTabs,
  currentItemId,
  authoredQuestions,
  isItemDetailView,
  isQuestionEditView,
  clearAnswers,
}) => {
  const [popoverVisible, setPopoverVisible] = useState(false)

  const [selectedLanguages, setSelectedLanguages] = useState([])

  const [itemLevelLanguageTabs, setItemLevelLanguageTabs] = useState([])

  useEffect(() => {
    if (
      isItemDetailView &&
      (item?.data?.questions?.length ||
        item?.data?.resources?.length ||
        passage?.data?.length)
    ) {
      const allAvailableLanguagesInItemAndPassages = new Set([
        ...getAvailableLanguageKeysInItem(item),
        ...getAvailableLanguageKeysInPassage(passage),
      ])
      const languageCodes = Array.from(allAvailableLanguagesInItemAndPassages)
      setItemLevelLanguageTabs(
        languageCodes.length ? languageCodes : [LANGUAGE_EN]
      )
      setLanguage({ languageCode: languageCodes[0] || LANGUAGE_EN })
    }
  }, [
    isItemDetailView,
    item?.data?.questions,
    item?.data?.resources,
    passage?.data,
  ])

  useEffect(() => {
    if (isQuestionEditView || isLCB) {
      const data = authoredQuestions?.[currentItemId]
      const allAvailableLanguagesInQuestion = getAvailableLanguageKeysInItem({
        data: { questions: [data] },
      })
      const languageCodes =
        allAvailableLanguagesInQuestion?.length > 0
          ? allAvailableLanguagesInQuestion
          : languageTabs?.length > 0
          ? languageTabs
          : [LANGUAGE_EN]

      const sortedLanguageTabs = filterAndOrderByLanguageOptions(languageCodes)
      setLanguageTabs(sortedLanguageTabs)
      setSelectedLanguages(sortedLanguageTabs)
      setLanguage({ languageCode: sortedLanguageTabs[0] || LANGUAGE_EN })
    }
  }, [isQuestionEditView, isLCB, currentItemId])

  const handleSelectedLang = (checked, lang) => {
    if (checked) {
      setSelectedLanguages(
        filterAndOrderByLanguageOptions([...selectedLanguages, lang])
      )
    } else {
      setSelectedLanguages(
        filterAndOrderByLanguageOptions(
          selectedLanguages.filter((l) => l !== lang)
        )
      )
    }
  }

  const handleSaveLanguage = () => {
    const sortedLanguageTabs = filterAndOrderByLanguageOptions([
      ...selectedLanguages,
    ])

    setSelectedLanguages([...sortedLanguageTabs])
    setLanguageTabs(sortedLanguageTabs)
    setLanguage({
      languageCode: sortedLanguageTabs[0] || LANGUAGE_EN,
      isSavingLanguageTabs: true,
    })
  }

  const handleChangeLanguage = ({ key }) => {
    setLanguage({ languageCode: key })
    clearAnswers()
  }

  const languageTabsToShow = isItemDetailView
    ? itemLevelLanguageTabs.length
      ? itemLevelLanguageTabs
      : [LANGUAGE_EN]
    : languageTabs.length
    ? languageTabs
    : [LANGUAGE_EN]

  const showAddLanguageButton =
    allowedToSelectMultiLanguage && isEditView && !isItemDetailView

  return {
    popoverVisible,
    setPopoverVisible,
    selectedLanguages,
    setSelectedLanguages,
    itemLevelLanguageTabs,
    setItemLevelLanguageTabs,
    showAddLanguageButton,
    languageTabsToShow,
    handleChangeLanguage,
    handleSaveLanguage,
    handleSelectedLang,
  }
}

export default useQuestionLanguageTab
